import { groupBy, IDataLayerType, labels, LayerTypeGroupId } from "../../omnia"
import { SourceLayerType, SourceLayerViewModel } from "./types"

export function getLayerTypes(layers: SourceLayerViewModel[]): SourceLayerType[] {

    const types = groupBy(
        layers,
        l => ({
            type: l.type,
            typeId: (l.type ? l.type.TypeId : null) || 0,
            g: getGroupInfo(l.type),
        }),
        t => t.type ? t.type.TypeId : 0
    )

    return types
        .map(t => ({
            layers: t.values,
            text: getTypeName(t.key.type, t.values),
            typeId: t.key.typeId,
            g: t.key.g
        }))
        .sort((a, b) =>
            (a.g.group - b.g.group)
            || (a.g.subgroup - b.g.subgroup)
            || (a.typeId - b.typeId)
            || (a.text.localeCompare(b.text)))
        .map(a => ({
            layers: a.layers.sort((a, b) => (b.year || 0) - (a.year || 0)),
            group: a.g.text,
            text: a.text
        }))

}

function getTypeName(type: IDataLayerType, layers: SourceLayerViewModel[]) {

    if ((!type) || (layers.length == 1)) {
        return layers[0].getLayerDescription()
    }

    return type.Name

}
function getGroupInfo(type: IDataLayerType) {

    const group = (type ? type.GroupId : null) || LayerTypeGroupId.Other
    const subgroup = (type ? type.SubgroupId : null) || 0

    const groupText = labels.LayerTypeGroupId(group)
    const subgroupText = subgroup ? labels.LayerTypeSubgroupId(subgroup) : null

    const text = [groupText, subgroupText].filter(t => !!t).join(" - ")

    return { group, subgroup, text }

}
